import RecyclingMaterialsService from 'src/modules/recyclingMaterials/recyclingMaterialsService';
import Errors from 'src/modules/shared/error/errors';
import { navigateTo } from 'src/view/shared/routes/helpers';

const prefix = 'RECYCLINGMATERIALS_VIEW';

const recyclingMaterialsViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,
  FIND_RESET: `${prefix}_FIND_RESET`,

  reset: () => async (dispatch) => {
    dispatch({
      type: recyclingMaterialsViewActions.FIND_RESET,
    });
  },

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: recyclingMaterialsViewActions.FIND_STARTED,
      });

      const record = await RecyclingMaterialsService.find(id);

      dispatch({
        type: recyclingMaterialsViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: recyclingMaterialsViewActions.FIND_ERROR,
      });

      navigateTo('/library/recycling-materials');
    }
  },
};

export default recyclingMaterialsViewActions;
